import { render } from "./TheSwitchButton.vue?vue&type=template&id=252571d1"
import script from "./TheSwitchButton.vue?vue&type=script&lang=js"
export * from "./TheSwitchButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__